<template>
  <!-- 用户选择（复用通用EmployeeSelector：部门导航+姓名/拼音/工号/手机号搜索），v-model绑定用户uuid，select事件返回完整用户对象 -->
  <EmployeeSelector single title="选择用户" @change="onChange">
    <a-button :disabled="disabled">
      <a-icon type="user" />
      <span style="margin: 0 2px">{{ currentName || placeholder }}</span>
      <a-icon
        v-if="currentName && !disabled"
        type="close-circle"
        theme="filled"
        class="clear-icon"
        title="清除已选"
        @click.stop="clear"
      />
    </a-button>
  </EmployeeSelector>
</template>

<script>
import EmployeeSelector from "@/components/employee-selector";

export default {
  name: "user-select",

  components: { EmployeeSelector },

  props: {
    value: { type: String, default: undefined },
    placeholder: { type: String, default: "选择用户" },
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {
      // uuid -> 姓名 映射（本实例内选过的用户用于按钮回显）
      nameMap: {},
    };
  },

  computed: {
    currentName() {
      if (!this.value) {
        return "";
      }
      return this.nameMap[this.value] || "已选用户";
    },
  },

  methods: {
    // 单选确认：把员工对象归一化为用户对象（uuid=用户主键userId、deptName=部门名）
    onChange(arr) {
      const emp = Array.isArray(arr) && arr.length > 0 ? arr[0] : null;
      if (!emp) {
        this.clear();
        return;
      }
      if (emp.userId) {
        this.nameMap = { ...this.nameMap, [emp.userId]: emp.name };
      }
      const user = {
        ...emp,
        uuid: emp.userId,
        deptName: emp.deptUniqueName,
      };
      this.$emit("input", user.uuid);
      this.$emit("select", user);
    },
    clear() {
      this.$emit("input", undefined);
      this.$emit("select", null);
    },
  },
};
</script>

<style scoped>
.clear-icon {
  color: #bfbfbf;
  margin-left: 4px;
}
.clear-icon:hover {
  color: #f5222d;
}
</style>
